define.alias("shared/components/shared/upgrade/trial-info", "media/components/shared/upgrade/trial-info");